namespace CSConnect {
   export function firebaseConfig() {
      return {
         apiKey: "AIzaSyCOPg09ZqJayfSIVdiyn6JFUQEF5IPv2T4",
         authDomain: "continuity-gifting-app.firebaseapp.com",
         databaseURL: "https://continuity-gifting-app-default-rtdb.firebaseio.com",
         projectId: "continuity-gifting-app",
         storageBucket: "continuity-gifting-app.appspot.com",
         messagingSenderId: "814625968432",
         appId: "1:814625968432:web:6ec7bad94761bcf99eb8f5",
         measurementId: "G-76CXQ7JZXF"
      }
   }

   export function getBaseUrl(dev?: true) {
      if ((dev ?? false)) {
         return `http://localhost:5001/continuity-gifting-app/us-central1`
      }
      return `https://us-central1-continuity-gifting-app.cloudfunctions.net`
   }
}

export { default as Casinos } from './Casinos'
export { default as Members } from './Members'
export { default as Gifts } from './Gifts'
export { default as Orders } from './Orders'
export { default as Users } from './Users'
export { default as Promotions } from './Promotions'
export { default as Vouchers } from './Vouchers'
export { default as Admin } from './Admin'
export { default as Support } from './Support'
export { default as Settings } from './Settings'
export { default as Plugins } from './Plugins'

export default CSConnect
